import React from "react";
import Select from "react-select";

import config from "config.json";

function Account({ isReadOnly = false, roleDetails, calcSubRole }) {
  return (
      <>
        <div className="field">
          <div className="field">
            <label className="label">Cargo no clube</label>
            <Select
            isDisabled={isReadOnly}
            value={roleDetails}
            onChange={(evt) => {
              calcSubRole('Other', evt.value)
            }}
            options={config.POSITIONS_OTHER}
          />
          </div>
        </div>
  
        <div className="field">
          {/* <TeamHistory
            setHistory={setHistory}
            history={roleDetails["history"] ? roleDetails["history"] : []}
          ></TeamHistory> */}
          <ul className="space-list"></ul>
        </div>
      </>
    );
}

export default Account;
